import { Stack, useTheme } from "@mui/material";
import { ReportHasNoChemicalsAlert } from "components/Alerts/ReportHasNoChemicalsAlert";
import { Permission, TierIiReportStep } from "generated-graphql/graphql";
import { useAuthorization } from "hooks/useAuthorization";
import { useMatch } from "react-router-dom";
import { reportStepMetadata } from "util/reportStepMetadata";

import { OverviewCards } from "./OverviewCards";
import { ReviewForm } from "./Review/ReviewForm";
import { StepperPageHeader } from "./StepperPageHeader";
import { useReport } from "./useReport";

export const Overview: React.FC = () => {
  const theme = useTheme();
  const match = useMatch({
    path: "/o/:tenantId/chemicals/reports/:reportId/:step",
    end: false,
  });
  const { hasPermissionForFacility } = useAuthorization();
  const { data } = useReport();

  const canVerifyAndSubmit = hasPermissionForFacility(data?.tierIIReport?.facility.id ?? "", [
    Permission.VerifyTierIiReport,
  ]);

  const isViewingReview = match?.params.step === "review";

  const title = isViewingReview ? "Review" : "Report Overview";
  const overviewDescription = isViewingReview
    ? reportStepMetadata.REVIEW.getOverviewDescription()
    : reportStepMetadata.REPORT_OVERVIEW.getOverviewDescription();

  const hiddenSteps = isViewingReview
    ? [TierIiReportStep.Review, TierIiReportStep.VerifyAndSubmit]
    : [];

  if (!canVerifyAndSubmit) {
    hiddenSteps.push(TierIiReportStep.VerifyAndSubmit);
  }

  return (
    <Stack
      gap={theme.spacing(0.5)}
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: "100%",
      }}
    >
      <StepperPageHeader header={title} description={overviewDescription} />

      <ReportHasNoChemicalsAlert />

      <OverviewCards showIssueDescriptions={!isViewingReview} hideSteps={hiddenSteps} />

      {isViewingReview && <ReviewForm />}
    </Stack>
  );
};
